(function () {
  function setupSwatches(card) {
    var swatchContainer = card.querySelector('.product-card-swatches');
    if (!swatchContainer) return;

    var swatchList = Array.from(card.querySelectorAll('.product-card-swatch'));
    var primaryImage = card.querySelector('.product-primary-image');
    var secondaryImage = card.querySelector('.product-secondary-image');

    // Read the original secondary srcset from data-srcset (set in HTML before lazySizes unveils it)
    // so we can restore it after a click, ensuring hover always shows a different image from primary.
    var orgSecondarySrcset = secondaryImage
      ? (secondaryImage.getAttribute('data-srcset') || secondaryImage.getAttribute('srcset') || '')
      : '';

    swatchList.forEach(function (swatch) {
      // Capture mouseover — prevents app.js from changing only the secondary image on swatch hover.
      swatch.addEventListener('mouseover', function (evt) {
        evt.stopImmediatePropagation();
      }, true);

      // Capture click — overrides app.js navigate-on-click.
      swatch.addEventListener('click', function (evt) {
        evt.stopImmediatePropagation();
        evt.preventDefault();

        // Active state
        swatchList.forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        // Update primary image to the selected variant / sibling image
        if (primaryImage && swatch.dataset.srcset) {
          primaryImage.setAttribute('srcset', swatch.dataset.srcset);
        }

        // Update secondary to the swatch's own second image when available
        // (data-secondary-srcset on sibling swatches), otherwise fall back to
        // the original product second image so hover always differs from primary.
        var newSecondarySrcset = (swatch.dataset.secondarySrcset && swatch.dataset.secondarySrcset.length > 0)
          ? swatch.dataset.secondarySrcset
          : orgSecondarySrcset;
        if (secondaryImage && newSecondarySrcset) {
          secondaryImage.setAttribute('srcset', newSecondarySrcset);
        }

        // Update all card links to the selected variant / sibling URL
        if (swatch.dataset.href) {
          card.querySelectorAll('a.product-featured-image-link, a.product-card-title').forEach(function (link) {
            link.href = swatch.dataset.href;
          });
        }

        // Keep size-options master variant in sync (if the feature is active)
        if (card.current_options !== undefined && card.color_index !== undefined) {
          var label = swatch.querySelector('span');
          if (label) {
            card.current_options[card.color_index] = label.innerText;
            if (typeof card.updateMasterId === 'function') {
              card.updateMasterId();
            }
          }
        }
      }, true);
    });
  }

  function init() {
    document.querySelectorAll('product-card').forEach(setupSwatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
